import type { CancelToken } from 'axios';
import { CommonUtility } from '../common';
import { BaseService } from './base';

export class CRUDService<T = any> {
  private url: string;
  private isLamdaRequest: boolean;
  private isSecure: boolean;

  constructor(url: string, isLamdaRequest = false, isSecure = true) {
    this.url = url;
    this.isLamdaRequest = isLamdaRequest;
    this.isSecure = isSecure;
  }

  get(params?: Record<string, any>, cancelToken?: CancelToken): Promise<T> {
    const query = params ? `?${CommonUtility.objectToParams(params)}` : '';
    const url = `${this.url}${query}`;
    return BaseService.get<T>(url, this.isLamdaRequest, this.isSecure, cancelToken);
  }

  getById(id: string | number): Promise<T> {
    const url = `${this.url}/${id}`;
    return BaseService.get<T>(url, this.isLamdaRequest, this.isSecure);
  }

  add(data: Partial<T>): Promise<T> {
    return BaseService.post<T>(this.url, data, this.isLamdaRequest, this.isSecure);
  }

  update(id: string | number | null, data: Partial<T>): Promise<T> {
    let url = `${this.url}`;
    if (id) {
      url += `/${id}`;
    }
    return BaseService.put<T>(url, data, this.isLamdaRequest, this.isSecure);
  }

  remove(id: string | number): Promise<T> {
    const url = `${this.url}/${id}`;
    return BaseService.remove<T>(url, this.isLamdaRequest, this.isSecure);
  }
}
